const QuotePublicPage = () => import('./pages/QuotePublicPage.vue');

const routes = [
    {
        path: '/:appId/:xid',
        name: 'quote',
        component: QuotePublicPage,
        meta: {
            title: 'public.quote.viewTitle',
        },
    },
];

export default routes;
